import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiStar } = FiIcons;

const MembershipCard = ({
  plan,
  isSelected,
  onSelect,
  isActive,
  isExpired,
  currentPlan,
  onPay,
  showPay,
  activatingId,
}) => {
  // Format the duration in months
  const formatDuration = (days) => {
    const months = Math.floor(days / 30);
    return months === 1 ? '1 Month' : `${months} Months`;
  };

  // Format the application limit
  const formatApplicationLimit = (limit) => {
    return limit === null ? 'Unlimited' : limit;
  };

  return (
    <motion.div
      whileHover={{ y: -5 }}
      className={`relative p-6 h-full flex flex-col rounded-lg transition-all duration-300 ${
        isSelected ? 'ring-2 ring-primary-500 shadow-lg' : 'border border-gray-200 shadow'
      } ${isActive ? 'bg-gradient-to-br from-primary-50 to-blue-50' : 'bg-white'}`}
    >
      {/* Popular badge */}
      {plan.name === 'Standard Plan' && (
        <div className="absolute top-0 right-0 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white px-3 py-1 text-xs font-semibold rounded-bl-lg rounded-tr-lg">
          Most Popular
        </div>
      )}

      {/* Current plan badge */}
      {currentPlan && (
        <div className="absolute top-0 left-0 bg-gradient-to-r from-green-500 to-green-600 text-white px-3 py-1 text-xs font-semibold rounded-br-lg rounded-tl-lg">
          Current Plan
        </div>
      )}

      {/* Expired badge */}
      {isExpired && (
        <div className="absolute top-0 left-0 bg-gradient-to-r from-red-500 to-red-600 text-white px-3 py-1 text-xs font-semibold rounded-br-lg rounded-tl-lg">
          Expired
        </div>
      )}

      <div className={`bg-gradient-to-r ${
        plan.name === 'Basic Plan' ? 'from-blue-500 to-blue-600' :
        plan.name === 'Standard Plan' ? 'from-purple-500 to-purple-600' :
        'from-yellow-500 to-yellow-600'
      } text-white p-6 rounded-lg mb-6`}>
        <h2 className="text-xl font-semibold mb-1">{plan.name}</h2>
        <div className="flex items-end">
          <span className="text-3xl font-bold">₹{plan.price}</span>
          <span className="ml-1 text-white opacity-90">/ {formatDuration(plan.duration_days)}</span>
        </div>
        <p className="mt-2 text-white opacity-90">{plan.description}</p>
      </div>

      <div className="mb-6">
        <div className="flex items-center mb-4">
          <SafeIcon icon={FiStar} className="w-5 h-5 text-primary-600 mr-2" />
          <span className="font-semibold text-gray-900">
            {plan.application_limit === null ? 'Unlimited Applications' : `${plan.application_limit} Applications`}
          </span>
        </div>
        <ul className="space-y-2">
          {plan.features.map((feature, i) => (
            <li key={i} className="flex items-start">
              <SafeIcon 
                icon={FiCheck} 
                className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" 
              />
              <span className="text-gray-600">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-auto space-y-2">
        <Button
          onClick={() => onSelect(plan)}
          variant={isSelected ? 'primary' : 'outline'}
          className="w-full"
          disabled={currentPlan && !isExpired}
        >
          {currentPlan && !isExpired ? 'Current Plan' : 
           isSelected ? 'Selected' : 'Select Plan'}
        </Button>
        {showPay && !currentPlan && (
          <Button
            onClick={() => onPay && onPay(plan)}
            className="w-full"
            disabled={!!activatingId}
            loading={activatingId === plan.id}
          >
            Pay ₹{plan.price}
          </Button>
        )}
      </div>
    </motion.div>
  );
};

export default MembershipCard;